import React, { useState, useEffect } from 'react';
import './Dashboard.css'; 
import Sidebar from './Sidebar';
import AddProjectModal from './AddProjectModal';
import projectService from '../../api/projectService'; // Import your new service

const Projects = () => {
  const [isToggled, setIsToggled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  
  // Modal States
  const [showModal, setShowModal] = useState(false);
  const [currentEditProject, setCurrentEditProject] = useState(null);
  
  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;

  // Project Data State (Initialized empty for API)
  const [projectData, setProjectData] = useState([]);

  // --- API LOGIC ---

  // 1. Fetch List
  const fetchProjects = async () => {
    try {
      setLoading(true);
      const data = await projectService.getAllProjects();
      setProjectData(data);
    } catch (error) {
      console.error("Failed to load projects:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCreateProject = async (formData) => {
    try {
      await projectService.addProject(formData);
      await fetchProjects(); // Refresh the table
    } catch (error) {
      console.error("Create failed:", error);
      throw error; // Pass error back to modal to show in red box
    }
  };

  // 3. UPDATE PROJECT (The fix for Line 219)
  const handleUpdateProject = async (formData) => {
    try {
      // Assuming formData contains _id from the edit state
      await projectService.updateProject(formData._id, formData);
      await fetchProjects(); // Refresh the table
    } catch (error) {
      console.error("Update failed:", error);
      throw error; // Pass error back to modal
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  // 2. Delete Project (using POST as requested)
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      try {
        await projectService.deleteProject(id);
        // Refresh local state
        setProjectData(prev => prev.filter(project => project._id !== id));
      } catch (error) {
        alert("Delete failed: " + error);
      }
    }
  };

  // --- UI LOGIC ---

  const filteredProjects = projectData.filter(project => 
    project.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const currentRecords = filteredProjects.slice(firstIndex, lastIndex);
  const nPages = Math.ceil(filteredProjects.length / recordsPerPage);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const openAddModal = () => {
    setCurrentEditProject(null);
    setShowModal(true);
  };

  const openEditModal = (project) => {
    setCurrentEditProject(project);
    setShowModal(true);
  };

  return (
    <div className={`d-flex ${isToggled ? 'toggled' : ''}`} id="wrapper">
      <Sidebar />

      <div id="page-content-wrapper" className="bg-light flex-grow-1">
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom px-4 shadow-sm sticky-top">
          <div className="d-flex align-items-center w-100">
            <i className="bi bi-list fs-4 me-3 cursor-pointer" onClick={() => setIsToggled(!isToggled)}></i>
            <h5 className="mb-0 fw-bold">Management Panel</h5>
            <div className="ms-auto d-flex align-items-center">
                <span className="text-muted small fw-medium me-3">Admin / Projects</span>
            </div>
          </div>
        </nav>

        <div className="container-fluid p-4">
          <div className="card border-0 shadow-sm" style={{ borderRadius: '15px', overflow: 'hidden' }}>
            
            <div className="card-header bg-white border-0 pt-4 px-4 pb-2">
              <div className="mb-3">
                <h6 className="fw-bold mb-0" style={{ color: '#1e293b', fontSize: '18px' }}>Infrastructure Projects</h6>
                <p className="text-muted mb-0" style={{ fontSize: '12.5px' }}>
                  {loading ? 'Syncing...' : `Total ${filteredProjects.length} projects found.`}
                </p>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="input-group shadow-sm" style={{ width: '350px', borderRadius: '10px', overflow: 'hidden' }}>
                  <span className="input-group-text bg-white border-end-0 px-3">
                    <i className="bi bi-search text-muted"></i>
                  </span>
                  <input 
                    type="text" 
                    className="form-control border-start-0 ps-1" 
                    placeholder="Search by project title..." 
                    onChange={handleSearch}
                  />
                </div>

                <button className="btn btn-primary px-4 shadow-sm" onClick={openAddModal}>
                  <i className="bi bi-plus-lg me-2"></i> Add New Project
                </button>
              </div>
            </div>
            
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light">
                    <tr className="text-muted text-uppercase" style={{ fontSize: '11px', fontWeight: '700' }}>
                      <th className="ps-4 py-3">S.No</th>
                      <th>Project Details</th>
                      <th>Category</th>
                      <th>Location</th>
                      <th>Budget</th>
                      <th>Status</th>
                      <th className="text-end pe-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                       <tr><td colSpan="7" className="text-center py-5">Loading project data...</td></tr>
                    ) : currentRecords.length > 0 ? (
                      currentRecords.map((project, index) => (
                        <tr key={project._id}>
                          <td className="ps-4 text-muted">{firstIndex + index + 1}</td>
                          <td className="py-3">
                            <div className="d-flex align-items-center">
                              <img
                                src={
                                  project.img
                                    ? project.img.replace('src/uploads', 'uploads')
                                    : 'https://via.placeholder.com/150?text=No+Image'
                                }
                                alt={project.title}
                                className="rounded shadow-sm me-3"
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  objectFit: 'cover',
                                  border: '1px solid #eee'
                                }}
                                // onError={(e) => {
                                //   e.target.src = 'https://via.placeholder.com/150?text=Error';
                                // }}
                              />
                              <div>
                                <div className="fw-bold" style={{ fontSize: '14px', color: '#1e293b' }}>{project.title}</div>
                                <small className="text-muted" style={{ fontSize: '11px' }}>ID: {project._id?.slice(-6)}</small>
                              </div>
                            </div>
                          </td>
                          <td><span className="badge bg-light text-dark border fw-normal">{project.category}</span></td>
                          <td><i className="bi bi-geo-alt me-1 text-primary"></i>{project.location}</td>
                          <td className="fw-bold">{project.budget}</td>
                          <td>
                            <span
                              className={`badge rounded-pill ${
                                project.isActive ? 'bg-success-subtle text-success' : 'bg-primary-subtle text-primary'
                              } px-3 py-2`}
                            >
                              {project.isActive ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td className="text-end pe-4">
                            <div className="d-flex justify-content-end gap-2">
                              <button className="btn btn-sm btn-light border" onClick={() => openEditModal(project)}>
                                <i className="bi bi-pencil text-primary"></i>
                              </button>
                              <button className="btn btn-sm btn-light border" onClick={() => handleDelete(project._id)}>
                                <i className="bi bi-trash text-danger"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="7" className="text-center py-5 text-muted">No projects found.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-footer bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
              <small className="text-muted">
                Showing {currentRecords.length} entries
              </small>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Previous</button>
                  </li>
                  {[...Array(nPages)].map((_, i) => (
                    <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === nPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <AddProjectModal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        onAdd={handleCreateProject}   // This MUST match the name in Modal props
        onEdit={handleUpdateProject}  // This MUST match the name in Modal props
        onRefresh={fetchProjects} 
        editData={currentEditProject}
      />
    </div>
  );
};

export default Projects;